<div class="login-page">
  <div class="login-content">
    <div class="login-logo-section">
      <img
        [src]="
          helper.darkTheme
            ? 'assets/images/irix_logo_dark.png'
            : 'assets/images/irix_logo.png'
        "
        alt="IRIX"
        class="login-logo"
      />
      <span class="login-tagline">Inteligencia que protege</span>
    </div>

    <mat-card class="login-card" appearance="outlined">
      @if (form) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" subscriptSizing="fixed" class="login-field">
            <mat-label>Email</mat-label>
            <mat-icon matPrefix>email</mat-icon>
            <input
              matInput
              type="email"
              required
              formControlName="email"
              autocomplete="email"
            />
            @if (form.get('email')?.invalid && form.get('email')?.touched) {
              <mat-error>Ingresá un email válido</mat-error>
            }
          </mat-form-field>

          @if (!emailSent) {
            <button
              irxBoton="principal"
              bloque
              tamano="campo"
              type="submit"
              class="login-button"
              [disabled]="!form.valid || loading.getLoading()"
            >
              <mat-icon>send</mat-icon>
              Enviar
            </button>
          }

          @if (emailSent) {
            <div class="success-message">
              <mat-icon color="primary">check_circle</mat-icon>
              <p>
                Si el email está registrado, vas a recibir un mensaje con las
                instrucciones para resetear la contraseña.
              </p>
            </div>
          }
        </form>
      }

      <div class="back-to-login">
        <button
          irxBoton="secundario"
          bloque
          tamano="campo"
          class="login-button"
          (click)="goBackToLogin()"
        >
          <mat-icon>arrow_back</mat-icon>
          Volver al inicio de sesión
        </button>
      </div>

      <mat-progress-bar
        color="primary"
        [mode]="loading.getLoading() ? 'indeterminate' : 'determinate'"
        class="login-progress"
      ></mat-progress-bar>
    </mat-card>
  </div>

  <footer class="login-footer">
    {{ envService.APP_VERSION }} · &copy; GPE Sistemas 2026
  </footer>
</div>
